import {
  IconEmail,
  SequenceMenu,
  SettingsFormControl,
  SettingsFormControlIcon,
  useModalState,
  useNotifications,
  SimpleModal,
  Box
} from '@sequencehq/core-components'
import { useMutation } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { useNavigate } from 'react-router-dom'
import {
  getNotificationSummary,
  NotificationPolicy
} from './nofitications.utils'

export const NotificationPolicyCard = ({
  policy
}: {
  policy: NotificationPolicy
}) => {
  const navigate = useNavigate()
  const { displayNotification } = useNotifications()
  const { isModalOpen, openModal, closeModal } = useModalState()

  const mutator = useMutation(
    dashboard20240730Client.deleteNotificationPolicy,
    {
      onSuccess() {
        displayNotification('Notification policy deleted', {
          type: 'success'
        })
      },
      onError() {
        displayNotification('Notification policy failed to delete ', {
          type: 'error'
        })
      }
    }
  )

  return (
    <>
      <SettingsFormControl
        key={policy.id}
        label={policy.name}
        htmlFor={`policy-${policy.id}`}
        helper={getNotificationSummary(policy.notificationTypes)}
        onClick={() => {
          navigate(`/settings/notifications/${policy.id}`)
        }}
        icon={
          <SettingsFormControlIcon>
            <IconEmail />
          </SettingsFormControlIcon>
        }
      >
        <SequenceMenu
          variant="ghost"
          buttonSize="medium"
          items={[
            {
              label: 'Edit',
              onClick: () => {
                navigate(`/settings/notifications/${policy.id}`)
              }
            },
            {
              label: 'Delete',
              style: { color: 'red' },
              onClick: e => {
                e.stopPropagation()
                openModal()
              }
            }
          ]}
        />
      </SettingsFormControl>
      <SimpleModal
        variant="dialog"
        data-testid="notifications.deleteDialog"
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Delete policy"
        submitButtonText="Delete"
        submittingButtonText="Deleting"
        isDestructive
        disableSubmitOnEnter
        onSubmit={async () => {
          try {
            await mutator.mutateAsync({ id: policy.id })
          } catch {
            return false
          }
          return true
        }}
      >
        Are you sure? This will permanently delete the <b>{policy.name}</b>{' '}
        notification policy.
      </SimpleModal>
    </>
  )
}
